export default "__VITE_ASSET__BbJ5wIPN__"